<div class="pt-6 md:w-96 bg-white">
  <div class="px-4">
    @if(title(); as title) {
      <h1 class="font-bold text-xl">{{ title | translate }}</h1>
    }
    <div [innerHTML]="description() | translate" class="wysiwyg"></div>
  </div>
  <div class="p-4 flex justify-end sticky bottom-0 bg-white">
    <button (click)="close()" class="button primary sm" type="button">{{ 'common.modal.close' | translate }}</button>
  </div>
</div>
